﻿import { ProjectTaskDialog } from "@/Projects/Projects/ProjectTaskDialog";
import { DocumentsRow } from "@/ServerTypes/Cemdo/Default.DocumentsRow";
import { TaskRow } from "@/ServerTypes/TimeTracking";
import { TaskGrid } from "@/TimeTracking/Task/TaskGrid";
import { Decorators } from "@serenity-is/corelib";


@Decorators.registerEditor("Profis.Default.DocumentTaskGrid")
export class DocumentTaskGrid extends TaskGrid {

    private _document: DocumentsRow;
    protected getDialogType() { return ProjectTaskDialog; }

    public set DocumentId(value: DocumentsRow) {
        if (value != this._document) {
            this.setEquality(TaskRow.Fields.DocumentId, value.DocumentId);
            this._document = value;
            this.refresh();
        }
    }

    getInitialTitle() {
        return null;
    }

    getColumns() {
        return super.getColumns().filter(x => x.field != TaskRow.Fields.ProjectContractNo);
    }

    getButtons() {
        return super.getButtons();
    }

    protected getQuickFilters() {
        return [];
    }

    getGridCanLoad() {
        return super.getGridCanLoad() && !!this._document;
    }

    addButtonClick() {
        if (!this._document)
            return;
        this.editItem(<TaskRow>{
            ProjectId: this._document.ProjectId,
            WbsElementId: this._document.WBSElementId,
            DocumentId: this._document.DocumentId,
            DataClass: "Document"
        });
    }
}
